import videocallshopApi from '../apis/videocallshop';

import { toastr } from 'react-redux-toastr';

import {
    FEATURED_PRODUCTS_FETCH_REQUESTED,
    FEATURED_PRODUCTS_FETCH_SUCCESS,
    FEATURED_PRODUCTS_FETCH_FAILED,
    STORE_CATALOG_FETCH_REQUESTED,
    STORE_CATALOG_FETCH_SUCCESS,
    STORE_CATALOG_FETCH_FAILED,
    STORE_PRODUCT_FETCH_REQUESTED,
    STORE_PRODUCT_FETCH_SUCCESS,
    STORE_PRODUCT_FETCH_FAILED,
} from './types';

export const STORE_CATALOG_PAGE_SIZE = 20;
export const FEATURED_PRODUCTS_LIMIT = 24;

// Feed del home: todos los productos visibles, intercalados por tienda.
// offset 0 = primera página (reemplaza); offset > 0 = scroll infinito (agrega).
// Sin toastr: si falla, el home muestra sólo las tiendas (es opcional, no
// queremos un error en la cara del comprador).
export const fetchFeaturedProducts = (
    offset = 0,
    limit = FEATURED_PRODUCTS_LIMIT
) => async (dispatch) => {
    dispatch({ type: FEATURED_PRODUCTS_FETCH_REQUESTED, payload: { offset } });

    try {
        const { data } = await videocallshopApi.get('/products/featured', {
            params: { limit, offset },
        });

        dispatch({
            type: FEATURED_PRODUCTS_FETCH_SUCCESS,
            payload: { offset, ...data.data },
        });
    } catch (err) {
        console.error('Error al cargar productos destacados:', err);
        dispatch({ type: FEATURED_PRODUCTS_FETCH_FAILED, payload: { offset } });
    }
};

// offset 0 = primera página (reemplaza); offset > 0 = "Ver más" (agrega).
export const fetchStoreCatalog = (storeId, offset = 0) => async (dispatch) => {
    dispatch({
        type: STORE_CATALOG_FETCH_REQUESTED,
        payload: { storeId, offset },
    });

    try {
        const {
            data,
        } = await videocallshopApi.get(`/stores/${storeId}/catalog`, {
            params: { limit: STORE_CATALOG_PAGE_SIZE, offset },
        });

        dispatch({
            type: STORE_CATALOG_FETCH_SUCCESS,
            payload: { storeId, offset, ...data.data },
        });
    } catch (err) {
        console.error('Error al cargar el catálogo:', err);
        dispatch({
            type: STORE_CATALOG_FETCH_FAILED,
            payload: { storeId, offset },
        });

        toastr.error(
            'Error de conexión',
            'No se pudieron cargar los productos de la tienda.'
        );
    }
};

export const fetchStoreProduct = (storeId, productId) => async (dispatch) => {
    dispatch({
        type: STORE_PRODUCT_FETCH_REQUESTED,
        payload: { productId },
    });

    try {
        const { data } = await videocallshopApi.get(
            `/stores/${storeId}/catalog/${productId}`
        );

        dispatch({
            type: STORE_PRODUCT_FETCH_SUCCESS,
            payload: { productId, product: data.data },
        });
    } catch (err) {
        const notFound = !!(err.response && err.response.status === 404);

        dispatch({
            type: STORE_PRODUCT_FETCH_FAILED,
            payload: { productId, notFound },
        });

        // el 404 tiene su propia pantalla ("ya no está disponible")
        if (!notFound) {
            console.error('Error al cargar el producto:', err);
            toastr.error('Error de conexión', 'No se pudo cargar el producto.');
        }
    }
};
